import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

// Components
import Navbar from '../navbar/Navbar';
import Loader from '../loader/Loader';

// Images
import hero_image from '../../img/hero_image.png';
import feature_card_1 from '../../img/feature_card_1.png';
import feature_card_2 from '../../img/feature_card_2.png';
import feature_card_3 from '../../img/feature_card_3.png';

//Pain Point icon
import pain_point_icon_1 from '../../img/pain_point_icon_1.png';
import pain_point_icon_2 from '../../img/pain_point_icon_2.png';
import pain_point_icon_3 from '../../img/pain_point_icon_3.png';
import pain_point_icon_4 from '../../img/pain_point_icon_4.png';

import flow_card_1 from '../../img/flow_card_1.png';
import flow_card_2 from '../../img/flow_card_2.png';
import flow_card_3 from '../../img/flow_card_3.png';
import flow_arrow_1 from '../../img/flow_arrow_1.png';
import flow_arrow_2 from '../../img/flow_arrow_2.png';

import state_of_art_icon_1 from '../../img/state_of_art_icon_1.png';
import state_of_art_icon_2 from '../../img/state_of_art_icon_2.png';
import state_of_art_icon_3 from '../../img/state_of_art_icon_3.png';
import state_of_art_icon_4 from '../../img/state_of_art_icon_4.png';
import state_of_art_icon_5 from '../../img/state_of_art_icon_5.png';
import state_of_art_icon_6 from '../../img/state_of_art_icon_6.png';

// Brand Logo
import amazon_logo from '../../img/brandLogo/amazon_logo.png';
import flipkart_logo from '../../img/brandLogo/flipkart_logo.png';
import firstcry_logo from '../../img/brandLogo/firstcry_logo.png';
import snapdeal_logo from '../../img/brandLogo/snapdeal_logo.png';
import swiggy_instamart_logo from '../../img/brandLogo/swiggy_instamart_logo.png';
import blinkit_logo from '../../img/brandLogo/blinkit_logo.png';
import tira_logo from '../../img/brandLogo/tira_logo.png';
import netmeds_logo from '../../img/brandLogo/netmeds_logo.png';
import amazon_fresh_logo from '../../img/brandLogo/amazon_fresh_logo.png';
import zepto_logo from '../../img/brandLogo/zepto_logo.png';
import nykaa_logo from '../../img/brandLogo/nykaa_logo.png';
import bigbasket_logo from '../../img/brandLogo/bigbasket_logo.png';
import tata1mg_logo from '../../img/brandLogo/tata1mg_logo.png';
import jiomart_logo from '../../img/brandLogo/jiomart_logo.png';
import purplle_logo from '../../img/brandLogo/purplle_logo.png';

import hero_image_2 from '../../img/hero_image_2.png';
import hero_image_3 from '../../img/hero_image_3.png';
import amazon_demo_snapshot from '../../img/amazon_demo_snapshot.png';

// CSS
import '../../css/landing/landing.css';
import Sidebar from '../sidebar/Sidebar';

const LandingPage = ({ auth: { isAuthenticated, user } }) => {
  const [paidButton, setPaidButton] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // State to manage active library
  const [activeLibrary, setActiveLibrary] = useState('Python');

  useEffect(() => {
    const fetchIpAddress = async () => {
      try {
        const response = await fetch('https://api.ipify.org?format=json');
        const data = await response.json();

        // Save the IP address in local storage
        localStorage.setItem('userIp', data.ip);
      } catch (error) {
        console.error('Error fetching IP address:', error);
      }
    };

    // Check if the user's IP address is already saved in local storage
    const savedUserIp = localStorage.getItem('userIp');
    if (!savedUserIp) {
      fetchIpAddress();
    }
  }, []);

  useEffect(() => {
    if (isAuthenticated && user) {
      setIsLoading(true);
      // console.log('user Authenticated');
      // console.log('user', user);

      if (user.is_paid) {
        // console.log('paid User', user.is_paid);
        setPaidButton(true);
        setIsLoading(false);
      } else {
        // console.log('no is_paid user');
        setIsLoading(false);
      }
    }
  }, [isAuthenticated, user]);

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <div className='flex min-h-screen'>
          {/* Sidebar */}
          <div className='w-64'>
            <Sidebar />
          </div>

          {/* Main Content Area */}
          <div className='flex-1 flex flex-col'>
            {/* Navbar */}
            <div className=''>
              <Navbar />
            </div>

            {/* Main Content */}
            <div className='overview-page-content-wrapper flex-1 bg-white'>
              {/* Hero Section */}
              <div className='flex flex-col justify-center min-h-screen md:flex-row items-center px-4 gap-8 max-w-7xl mx-auto'>
                {/* Left Side - Text Content */}
                <div className='text-left max-w-xl'>
                  <h1 className='hero-section-heading mb-6'>EcomNext API</h1>
                  <h2 className='hero-section-subheading mb-6'>
                    Data Scraping for <br />
                    <span className='hero-section-subheading-2'>
                      E-com
                    </span> and{' '}
                    <span className='hero-section-subheading-2'>Q-Com</span>{' '}
                    platforms
                  </h2>
                  <p className='hero-section-text mb-6'>
                    Get real-time market insights with our advanced data
                    solutions.
                  </p>

                  {/* Get Started Button */}
                  <Link
                    to='/pricing'
                    className='get-started-button inline-block px-6 py-2.5 rounded-lg transition duration-300'
                  >
                    Get Started
                  </Link>
                </div>

                {/* Right Side - Image */}
                <div className=''>
                  <img
                    src={hero_image}
                    alt='Hero'
                    className='hero-image object-contain'
                  />
                </div>
              </div>

              {/* Challenges Section - Pain Points */}
              <div className='max-w-7xl mx-auto px-4 py-20 flex flex-col md:flex-row items-center justify-between gap-8'>
                {/* Left Content */}
                <div>
                  <h2 className='challenge-section-heading mb-6 leading-snug'>
                    Critical pain points in{' '}
                    <span className='challenge-section-heading-2'>
                      E-Com & Q-Com
                    </span>
                  </h2>

                  {/* Flex layout with 2 items per row, content-based width */}
                  <div className='flex flex-col gap-4'>
                    <div className='flex  gap-4'>
                      <div className='flex challenge-section-tags items-center px-4 py-2'>
                        <img
                          src={pain_point_icon_1}
                          alt='Price Icon'
                          className='mr-2'
                        />
                        <span className=''>Price & Stock Tracking</span>
                      </div>
                      <div className='flex items-center challenge-section-tags px-4 py-2'>
                        <img
                          src={pain_point_icon_2}
                          alt='Scalability Icon'
                          className='mr-2'
                        />
                        <span className=''>Scalability Issues</span>
                      </div>
                    </div>
                    <div className='flex gap-4'>
                      <div className='flex items-center challenge-section-tags px-4 py-2'>
                        <img
                          src={pain_point_icon_3}
                          alt='Manual Icon'
                          className='mr-2'
                        />
                        <span className=''>Manual Effort</span>
                      </div>
                      <div className='flex items-center challenge-section-tags px-4 py-2'>
                        <img
                          src={pain_point_icon_4}
                          alt='Incomplete Icon'
                          className='mr-2'
                        />
                        <span className=''>Incomplete Data</span>
                      </div>
                    </div>
                  </div>

                  <p className='mt-6 challenge-section-note'>
                    <span className='text-[#FEBC5C]'>The need:</span> A robust,
                    automated, and real-time data extraction solution.
                  </p>
                </div>

                {/* Right Image */}
                <div className='flex justify-center'>
                  <img
                    src={hero_image_2}
                    alt='E-commerce Challenges'
                    className='challenge-section-image object-contain'
                  />
                </div>
              </div>

              {/* Stats Section */}
              <div className='max-w-7xl mx-auto py-16'>
                <div className='mx-auto'>
                  <div className='grid grid-cols-1 md:grid-cols-5 divide-y md:divide-y-0 md:divide-x divide-gray-300 text-center '>
                    {/* 1 */}
                    <div className='text-left px-4'>
                      <h3 className='stats-number'>95%+</h3>
                      <p className='stats-heading mt-2'>Data Accuracy</p>
                      <p className='stats-text mt-6'>
                        Cross-validation for precision
                      </p>
                    </div>

                    {/* 2 */}
                    <div className='text-left px-4'>
                      <h3 className='stats-number'>80%</h3>
                      <p className='stats-heading mt-2'>
                        Time saving in data collection.
                      </p>
                      <p className='stats-text mt-6'>
                        Eliminate manual scrapping, enabling faster decision
                        making.
                      </p>
                    </div>

                    {/* 3 */}
                    <div className='text-left px-4'>
                      <h3 className='stats-number'>95%+</h3>
                      <p className='stats-heading mt-2'>
                        Reduction in Stockouts
                      </p>
                      <p className='stats-text mt-6'>
                        Demand forecasting ensures optimal inventory levels.
                      </p>
                    </div>

                    {/* 4 */}
                    <div className='text-left px-4'>
                      <h3 className='stats-number'>95%+</h3>
                      <p className='stats-heading mt-2'>
                        Lower infrastructure cost.
                      </p>
                      <p className='stats-text mt-6'>
                        Reduces reliance on costly web scraping servers and
                        manual labour.
                      </p>
                    </div>

                    {/* 5 */}
                    <div className='text-left px-4'>
                      <h3 className='stats-number'>95%+</h3>
                      <p className='stats-heading mt-2'>
                        Faster competition pricing tracking.
                      </p>
                      <p className='stats-text mt-6'>
                        Detects price changes 5× faster than traditional
                        methods.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Brand Logos Section */}
              <div className='max-w-7xl mx-auto px-4 pb-20 mt-48'>
                <div className='space-y-4'>
                  {/* Row 1 */}
                  <div className='grid grid-cols-5'>
                    <div></div>
                    <div className='flex justify-center'>
                      <div className='brand-logo-box'>
                        <img src={amazon_logo} alt='Amazon' className='' />
                      </div>
                    </div>
                    <div></div>
                    <div className='flex justify-start'>
                      <div className='brand-logo-box'>
                        <img src={flipkart_logo} alt='Flipkart' className='' />
                      </div>
                    </div>
                    <div></div>
                  </div>

                  {/* Row 2 */}
                  <div className='grid grid-cols-5'>
                    <div className='flex justify-center'>
                      <div className='brand-logo-box'>
                        <img src={firstcry_logo} alt='FirstCry' className='' />
                      </div>
                    </div>
                    <div></div>
                    <div className='flex justify-start'>
                      <div className='brand-logo-box'>
                        <img src={snapdeal_logo} alt='Snapdeal' className='' />
                      </div>
                    </div>
                    <div></div>
                    <div className='flex justify-center'>
                      <div className='brand-logo-box'>
                        <img
                          src={swiggy_instamart_logo}
                          alt='Swiggy Instamart'
                          className=''
                        />
                      </div>
                    </div>
                  </div>

                  {/* Row 3 */}
                  <div className='grid grid-cols-5'>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div className='flex justify-center'>
                      <div className='brand-logo-box'>
                        <img src={blinkit_logo} alt='Blinkit' className='' />
                      </div>
                    </div>
                    <div></div>
                  </div>

                  {/* Row 4 */}
                  <div className='grid grid-cols-5'>
                    <div></div>
                    <div className='flex justify-start'>
                      <div className='brand-logo-box'>
                        <img src={tira_logo} alt='Tira' className='' />
                      </div>
                    </div>
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>

                  {/* Row 5 */}
                  <div className='grid grid-cols-5'>
                    <div className='flex justify-start'>
                      <div className='brand-logo-box'>
                        <img
                          src={netmeds_logo}
                          alt='Netmeds'
                          className='h-10'
                        />
                      </div>
                    </div>
                    <div></div>
                    <div className='flex justify-end'>
                      <div className='brand-logo-box'>
                        <img src={zepto_logo} alt='Zepto' className='h-10' />
                      </div>
                    </div>
                    <div></div>
                    <div className='flex justify-end'>
                      <div className='brand-logo-box'>
                        <img
                          src={amazon_fresh_logo}
                          alt='Amazon Fresh'
                          className=''
                        />
                      </div>
                    </div>
                  </div>

                  {/* Row 6 */}
                  <div className='grid grid-cols-5'>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>

                  {/* Row 7 */}
                  <div className='grid grid-cols-5'>
                    <div></div>
                    <div className='flex justify-end'>
                      <div className='brand-logo-box'>
                        <img src={nykaa_logo} alt='Nykaa' className='' />
                      </div>
                    </div>
                    <div></div>
                    <div className='flex justify-end'>
                      <div className='brand-logo-box'>
                        <img
                          src={bigbasket_logo}
                          alt='Big Basket'
                          className=''
                        />
                      </div>
                    </div>
                    <div></div>
                  </div>

                  {/* Row 8 */}
                  <div className='grid grid-cols-5'>
                    <div className='flex justify-center'>
                      <div className='brand-logo-box'>
                        <img src={tata1mg_logo} alt='Tata 1mg' className='' />
                      </div>
                    </div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div className='flex justify-center'>
                      <div className='brand-logo-box'>
                        <img
                          src={jiomart_logo}
                          alt='Jio Mart'
                          className='h-10'
                        />
                      </div>
                    </div>
                  </div>

                  {/* Row 9 */}
                  <div className='grid grid-cols-5'>
                    <div></div>
                    <div></div>
                    <div className='flex justify-center'>
                      <div className='brand-logo-box'>
                        <img
                          src={purplle_logo}
                          alt='Purplle'
                          className='h-10'
                        />
                      </div>
                    </div>
                    <div></div>
                    <div></div>
                  </div>

                  {/* Row 10 */}
                  <div className='grid grid-cols-5'>
                    <div></div>
                    <div></div>
                    <div className='brand-logo-text flex justify-center'>
                      + many more
                    </div>
                    <div></div>
                    <div></div>
                  </div>
                </div>
              </div>

              {/* Key Features Section */}
              <div className='max-w-7xl mx-auto px-4 py-12'>
                <h2 className='key-feature-heading mb-3 text-left'>
                  Key Features
                </h2>
                <p className='key-feature-subheading mb-3 text-left'>
                  Get real-time market insights with our advanced data
                  solutions.
                </p>

                {/* Feature Cards */}
                <div className='grid md:grid-cols-3 gap-6'>
                  {/* Card 1 */}
                  <div className='card-wrapper p-6 border-[1px] border-[#6E49A2] rounded-lg shadow-sm'>
                    <div className='mb-4'>
                      <img
                        src={feature_card_1}
                        alt='feature card 1'
                        className='card-icon mb-3.5'
                      />
                    </div>
                    <h3 className='card-heading mb-4'>
                      Real-Time Data Extraction
                    </h3>
                    <p className='card-text'>
                      Retrieve real-time product details, pricing, stock
                      availability, and specifications, ensuring accurate data
                      for informed decisions.
                    </p>
                  </div>

                  {/* Card 2 */}
                  <div className='card-wrapper p-6 border-[1px] border-[#6E49A2] rounded-lg shadow-sm'>
                    <div className='text-green-600 text-3xl mb-4'>
                      <img
                        src={feature_card_2}
                        alt='feature card 2'
                        className='card-icon mb-3.5'
                      />
                    </div>
                    <h3 className='card-heading mb-4'>
                      Effortless API Integration
                    </h3>
                    <p className='card-text'>
                      Our API comes with clear documentation and
                      developer-friendly support, allowing for smooth and quick
                      integration.
                    </p>
                  </div>

                  {/* Card 3 */}
                  <div className='card-wrapper p-6 border-[1px] border-[#6E49A2] rounded-lg shadow-sm'>
                    <div className='text-purple-600 text-3xl mb-4'>
                      <img
                        src={feature_card_3}
                        alt='feature card 3'
                        className='card-icon mb-3.5'
                      />
                    </div>
                    <h3 className='card-heading mb-4'>
                      Operational Efficiency
                    </h3>
                    <p className='card-text'>
                      Reduce manual data collection efforts, allowing businesses
                      to focus more on strategy, analysis, and decision making.
                    </p>
                  </div>
                </div>
              </div>

              {/* Final CTA Section */}
              <div className='bg-white py-16 px-4'>
                <div className='max-w-7xl final-cta-wrapper pl-4 mx-auto flex flex-col md:flex-row items-center justify-between gap-8'>
                  {/* Left Content */}
                  <div className='md:w-1/2'>
                    <h2 className='final-cta-heading leading-snug mt-7'>
                      Start using ecom APIs today and experience seamless
                    </h2>
                    <h3 className='final-cta-subheading mt-[54px]'>
                      E-Com & Q-Com automation!
                    </h3>

                    <ul className='mt-6 space-y-3 pl-3'>
                      <li className='flex items-start gap-2'>
                        <i className='fa-solid fa-circle-check text-[#00BE2C] mt-1 text-[20px]'></i>
                        <span className='final-cta-text'>
                          Get started in minutes – Simple onboarding, no complex
                          setup
                        </span>
                      </li>
                      <li className='flex items-start gap-2'>
                        <i className='fa-solid fa-circle-check text-[#00BE2C] mt-1 text-[20px]'></i>
                        <span className='final-cta-text'>
                          Our support team is available from 9 AM to 6 PM on all
                          working days
                        </span>
                      </li>
                      <li className='flex items-start gap-2'>
                        <i className='fa-solid fa-circle-check text-[#00BE2C] mt-1 text-[20px]'></i>
                        <span className='final-cta-text'>
                          6000 SKUs/month at the price of INR 999.
                        </span>
                      </li>
                    </ul>

                    <p className='mt-6 final-cta-note'>
                      Click below to buy now & elevate your business.
                    </p>

                    <Link
                      to='/pricing'
                      className='inline-flex items-center gap-2 mt-[18px] mb-[48px] px-8 py-2.5 final-cta-button rounded-lg transition'
                    >
                      Buy Now
                      <i className='fa-solid fa-circle-chevron-right'></i>
                    </Link>
                  </div>

                  {/* Right Image */}
                  <div className='md:w-1/2'>
                    <img
                      src={hero_image_3}
                      alt='Start Using APIs'
                      className='w-full rounded-xl'
                    />
                  </div>
                </div>
              </div>

              {/* Section: Why our APIs are State-of-the-art? */}
              <section className='max-w-7xl mx-auto px-6 py-12'>
                <h2 className='sota-heading mb-[62px] text-left'>
                  Why our APIs are State-of-the-art?
                </h2>

                <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-[54px]'>
                  {/* Card 1 */}
                  <div className='text-left'>
                    <img
                      src={state_of_art_icon_1}
                      alt='Comprehensive Platform Support'
                      className='sota-card-icon mb-3.5'
                    />
                    <h3 className='sota-card-heading mb-2'>
                      Comprehensive Platform Support
                    </h3>
                    <p className='sota-card-text'>
                      Covers leading e-commerce & Q-commerce marketplace.
                    </p>
                  </div>

                  {/* Card 2 */}
                  <div className='text-left'>
                    <img
                      src={state_of_art_icon_2}
                      alt='Cost-effective solution'
                      className='sota-card-icon mb-3.5'
                    />
                    <h3 className='sota-card-heading mb-2'>
                      Cost-effective solution
                    </h3>
                    <p className='sota-card-text'>
                      Reduces operational cost and infrastructure dependencies.
                    </p>
                  </div>

                  {/* Card 3 */}
                  <div className='text-left'>
                    <img
                      src={state_of_art_icon_3}
                      alt='Competitive market intelligence'
                      className='sota-card-icon mb-3.5'
                    />
                    <h3 className='sota-card-heading mb-2'>
                      Competitive market intelligence
                    </h3>
                    <p className='sota-card-text'>
                      Helps businesses track competitor strategies effectively.
                    </p>
                  </div>

                  {/* Card 4 */}
                  <div className='text-left'>
                    <img
                      src={state_of_art_icon_4}
                      alt='Optimized business insights'
                      className='sota-card-icon mb-3.5'
                    />
                    <h3 className='sota-card-heading mb-2'>
                      Optimized business insights
                    </h3>
                    <p className='sota-card-text'>
                      Enables data-driven decision-making for market dominance.
                    </p>
                  </div>

                  {/* Card 5 */}
                  <div className='text-left'>
                    <img
                      src={state_of_art_icon_5}
                      alt='Scalable & Flexible'
                      className='sota-card-icon mb-3.5'
                    />
                    <h3 className='sota-card-heading mb-2'>
                      Scalable & Flexible
                    </h3>
                    <p className='sota-card-text'>
                      Supports high volume data needs for startups to
                      enterprises.
                    </p>
                  </div>

                  {/* Card 6 */}
                  <div className='text-left'>
                    <img
                      src={state_of_art_icon_6}
                      alt='Industry Leading Expertise'
                      className='sota-card-icon mb-3.5'
                    />
                    <h3 className='sota-card-heading mb-2'>
                      Industry Leading Expertise
                    </h3>
                    <p className='sota-card-text'>
                      Extensive experience in web scraping, data analytics and
                      API development.
                    </p>
                  </div>
                </div>
              </section>

              {/* Section: How does it works? Flow Cards */}
              <section className='py-16 bg-white'>
                <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8'>
                  <h2 className='flow-card-section-heading mb-2'>
                    How does it works?
                  </h2>
                  <p className='flow-card-section-subheading mb-[38px]'>
                    Quickly access and use data in three steps:
                  </p>

                  <div className='flex flex-col lg:flex-row'>
                    {/* Left Side: Cards */}
                    <div className='flex flex-col gap-[14px] flex-1'>
                      {/* Card 1 */}
                      <div className='flow-card-wrapper p-2 w-full'>
                        <h3 className='flow-card-heading mb-1.5'>
                          Send a request
                        </h3>
                        <p className='flow-card-text'>
                          Use simple API requests with key authentication and
                          input parameters
                          <br />
                          (pincode & product ID / Link) to fetch data.
                        </p>
                      </div>

                      {/* Card 2 */}
                      <div className='flow-card-wrapper p-2 w-full'>
                        <h3 className='flow-card-heading mb-1.5'>
                          Retrieve Data
                        </h3>
                        <p className='flow-card-text'>
                          Get structured and real-time information on product
                          pricing, availability
                          <br />
                          and other key attributes.
                        </p>
                      </div>

                      {/* Card 3 */}
                      <div className='flow-card-wrapper p-2 w-full'>
                        <h3 className='flow-card-heading mb-1.5'>
                          Analyse & Act
                        </h3>
                        <p className='flow-card-text'>
                          Utilise extracted data for pricing strategies,
                          inventory management, and
                          <br />
                          competitor tracking.
                        </p>
                      </div>

                      {/* Note Below Cards */}
                      <div className='note-text mt-[24px] p-2 w-full'>
                        <span>
                          Note: The API is optimized to handle one Product ID
                          per request
                        </span>
                      </div>
                    </div>

                    {/* Right Side: Image */}
                    <div className='flex-1 flex flex-col items-center'>
                      <img
                        src={amazon_demo_snapshot}
                        alt='Amazon Demo Snapshot'
                        className='w-full h-auto object-contain'
                      />
                      <p className='text-[14px] text-[#636363] mt-4 italic'>
                        *image used for demonstration purpose only.
                      </p>
                    </div>
                  </div>
                </div>
              </section>

              {/* CTA Section: Ready to Start (2 CTAs Side by Side) */}
              <div className='flex flex-col md:flex-row gap-6 max-w-7xl mx-auto px-6 py-12'>
                {/* CTA Box 1 */}
                <div className='cta-wrapper flex-1 text-left px-6 py-8'>
                  <h2 className='cta-heading mb-3.5'>Ready to Start?</h2>
                  <p className='cta-subheading mb-7'>
                    Powerful APIs for data driven success — innovate, enhance
                    customer experience and, achieve your business goals with
                    confidence.
                  </p>
                  <Link
                    to='/pricing'
                    className='cta-button inline-flex items-center px-6 py-2.5 rounded-lg transition'
                  >
                    Buy Plan
                    <i className='fa-solid fa-circle-chevron-right ml-3'></i>
                  </Link>
                </div>

                {/* CTA Box 2 (Duplicate) */}
                <div className='cta-wrapper flex-1 text-left px-6 py-8'>
                  <h2 className='cta-heading mb-3.5'>For review extraction</h2>
                  <p className='cta-subheading mb-7'>
                    Get access to customer reviews and understand real user
                    sentiment around products. Want review data for your
                    analysis?
                  </p>
                  <Link
                    to='/contact-us'
                    className='cta-button inline-flex items-center px-6 py-2.5 rounded-lg transition '
                  >
                    Contact us
                    <i className='fa-solid fa-circle-chevron-right ml-3'></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {})(LandingPage);
